import { CategoryKey, MenuItem } from './types';

export const CATEGORY_LABELS: Record<CategoryKey, string> = {
  [CategoryKey.ALL]: 'Tổng hợp',
  [CategoryKey.DOCUMENTS]: 'Tài liệu',
  [CategoryKey.ERP]: 'Hệ thống ERP',
  [CategoryKey.SERVICE]: 'Yêu cầu',
  [CategoryKey.ADMIN]: 'Quản trị',
};

export const MENU_ITEMS: readonly MenuItem[] = [
  // ===== DOCUMENTS =====
  {
    id: 'policies',
    label: 'Chính sách Công ty',
    description: 'Tra cứu các quy định, nội quy và chính sách chung.',
    icon: 'fa-shield-halved',
    href: 'https://app.box.com/s/dzldjcfjkhbhay7q5yzx55ueccptmf1q',
    category: CategoryKey.DOCUMENTS,
    external: true,
    color: 'text-blue-500',
  },
  {
    id: 'sops',
    label: 'Quy trình SOP',
    description: 'Hướng dẫn quy trình vận hành tiêu chuẩn các phòng ban.',
    icon: 'fa-book-bookmark',
    href: 'https://drive.google.com/drive/folders/1rmvC-51IovWqaWafp0Qfs4c2e6dP_nGM',
    category: CategoryKey.DOCUMENTS,
    external: true,
    color: 'text-sky-500',
  },
  {
    id: 'general_guide',
    label: 'Thông tin và hướng dẫn ',
    description: 'Trang thông tin chung và hướng dẫn thao tác các ứng dụng làm việc nội bộ.',
    icon: 'fa-lightbulb',
    href: 'user_guide',
    category: CategoryKey.DOCUMENTS,
    color: 'text-cyan-500',
  },

  // ===== ERP REQUESTS =====
  {
    id: 'erp_create',
    label: 'Tạo đối tượng ERP',
    description: 'Yêu cầu khởi tạo mã vendor mới.',
    icon: 'fa-plus-circle',
    href: 'dashboard',
    category: CategoryKey.ERP,
    color: 'text-indigo-500',
  },
  {
    id: 'erp_bank',
    label: 'Cập nhật Ngân hàng',
    description: 'Thay đổi thông tin tài khoản ngân hàng trên ERP.',
    icon: 'fa-building-columns',
    href: 'update_bank_request',
    category: CategoryKey.ERP,
    color: 'text-violet-500',
  },
  {
    id: 'erp_edit',
    label: 'Chỉnh sửa ERP',
    description: 'Yêu cầu điều chỉnh các dữ liệu hiện có trên hệ thống.',
    icon: 'fa-pen-to-square',
    href: 'erp_edit_request',
    category: CategoryKey.ERP,
    color: 'text-purple-500',
  },
  {
    id: 'leave_request',
    label: 'Nghỉ phép',
    description: 'Gửi yêu cầu nghỉ phép và theo dõi trạng thái.',
    icon: 'fa-plane-departure',
    href: 'leave_request',
    category: CategoryKey.SERVICE,
    color: 'text-emerald-500',
  },
  {
    id: 'erp_report',
    label: 'Báo cáo ERP',
    description: 'Truy xuất báo cáo dữ liệu theo phòng ban.',
    icon: 'fa-chart-pie',
    href: 'department_report',
    category: CategoryKey.ERP,
    permission: 'hasViewReport',
    color: 'text-fuchsia-500',
  },

  // ===== SERVICE =====
  {
    id: 'seal_request',
    label: 'Ký số & Con dấu',
    description: 'Yêu cầu đóng dấu hoặc ký số điện tử cho văn bản.',
    icon: 'fa-signature',
    href: 'service_request',
    category: CategoryKey.SERVICE,
    color: 'text-emerald-500',
  },
  {
    id: 'data_upload',
    label: 'SFTP Data Upload',
    description: 'Tải lên dữ liệu lớn thông qua giao thức SFTP.',
    icon: 'fa-cloud-arrow-up',
    href: 'sftp_upload_request_v2',
    category: CategoryKey.SERVICE,
    color: 'text-teal-500',
  },

  // ===== APPROVALS =====
  {
    id: 'approve_seal',
    label: 'Duyệt Ký số',
    description: 'Phê duyệt các yêu cầu sử dụng con dấu/CKS.',
    icon: 'fa-file-signature',
    href: 'admin_service_approve',
    category: CategoryKey.SERVICE,
    permission: 'hasApprovalSeal',
    color: 'text-emerald-600',
  },
  {
    id: 'approve_erp',
    label: 'Duyệt yêu cầu ERP',
    description: 'Kiểm tra và phê duyệt các ticket ERP.',
    icon: 'fa-check-double',
    href: 'admin_erp_approve',
    category: CategoryKey.ERP,
    permission: 'hasApprovalErp',
    color: 'text-indigo-600',
  },
  {
    id: 'approve_sftp',
    label: 'Duyệt Upload SFTP',
    description: 'Phê duyệt quyền tải dữ liệu hệ thống.',
    icon: 'fa-user-check',
    href: 'admin_sftp_upload_approve',
    category: CategoryKey.SERVICE,
    permission: 'hasApprovalSftp',
    color: 'text-amber-600',
  },

  // ===== LEAVE APPROVAL (SUPER ADMIN) =====
  {
    id: 'approve_leave',
    label: 'Duyệt Nghỉ phép',
    description: 'Xem và phê duyệt các yêu cầu nghỉ phép.',
    icon: 'fa-calendar-check',
    href: 'admin_leave_approve',
    category: CategoryKey.SERVICE,
    permission: 'hasApprovalLeave', // thêm map permission ở backend
    color: 'text-emerald-700',
  },

  // ===== SUPER ADMIN =====
  {
    id: 'admin_it_assets',
    label: 'IT Asset Management',
    description: 'Quản lý thiết bị & tài sản IT',
    icon: 'fa-laptop',
    href: 'admin_it_assets',
    category: CategoryKey.ADMIN,
    isSuperAdminOnly: true,
    color: 'text-blue-500',
  },
  {
    id: 'admin_supplier',
    label: 'Quản lý Nhà Cung Cấp',
    description: 'Tạo NCC cho Users',
    icon: 'fa-truck-field',
    href: 'admin_supplier_requests',
    category: CategoryKey.ADMIN,
    isSuperAdminOnly: true,
    color: 'text-rose-500',
  },
  {
    id: 'admin_assign',
    label: 'Phân quyền Duyệt',
    description: 'Phân quyền duyệt ERP, CKS, SFTP, nghỉ phép',
    icon: 'fa-user-lock',
    href: 'admin_approvals_dashboard',
    category: CategoryKey.ADMIN,
    isSuperAdminOnly: true,
    color: 'text-orange-500',
  },
  {
    id: 'admin_departments',
    label: 'USER',
    description: 'Quản lý users và phòng ban',
    icon: 'fa-sitemap',
    href: 'create_user_and_assign_department',
    category: CategoryKey.ADMIN,
    isSuperAdminOnly: true,
    color: 'text-amber-500',
  },

  // ===== ACCOUNT =====

  {
    id: 'admin_leave_balance',
    label: 'Quản lý phép năm',
    description: 'Nhập số ngày phép năm cho tất cả nhân viên.',
    icon: 'fa-calendar-plus',
    href: 'admin_leave_balance',
    category: CategoryKey.ADMIN,
    permission: 'hasManageLeaveBalance',
    color: 'text-emerald-700',
  },
  {
    id: 'leave_calendar',
    label: 'Lịch nghỉ phép',
    description: 'Xem lịch nghỉ phép.',
    icon: 'fa-calendar-days',
    href: 'admin_leave_balance?tab=calendar',
    category: CategoryKey.SERVICE,
    permission: 'hasViewLeaveCalendar',
    color: 'text-emerald-700',
  },
  {
    id: 'approve_leave_cancel',
    label: 'Duyệt huỷ nghỉ phép',
    description: 'Xử lý yêu cầu huỷ nghỉ phép (HR/Quản lý phép năm).',
    icon: 'fa-rotate-left',
    href: 'admin_leave_approve?tab=cancel-pending',
    category: CategoryKey.SERVICE,
    permission: 'hasManageLeaveBalance',
    color: 'text-indigo-600',
  },
  {
    id: 'password',
    label: 'Mật khẩu',
    icon: 'fa-key',
    href: 'change_password',
    category: CategoryKey.ADMIN,
    color: 'text-slate-600',
  },

] as const;
